// extracted by mini-css-extract-plugin
export default {"backgroundSelectedBulk":"#ffe5a1","backgroundBulk":"#fff4d8","borderBulk":"#fcb400"};